import * as React from 'react';

import MobileMenuConfigWrapper from 'bundles/composable-page-header/components/grid-items/mobile/MobileMenuConfigWrapper';
import WrappedExploreConsumerSubmenu from 'bundles/composable-page-header/components/mobile-menu-items/ExploreConsumerSubmenu';
import ExploreMenuItem from 'bundles/composable-page-header/components/mobile-menu-items/ExploreMenuItem';
import GetAppMenuItem from 'bundles/composable-page-header/components/mobile-menu-items/GetAppMenuItem';
import MetaNavMenuItem from 'bundles/composable-page-header/components/mobile-menu-items/MetaNavMenuItem';
import MobileAuthMenuItem from 'bundles/composable-page-header/components/mobile-menu-items/MobileAuthMenuItem';
import { MOBILE_MAIN_IDENTIFIER, logInButtonProps, signUpButtonProps } from 'bundles/composable-page-header/constants';

const DefaultLoggedInMobileMenuConfig = () => {
  return (
    <MobileMenuConfigWrapper
      subPagesMap={{
        [MOBILE_MAIN_IDENTIFIER.EXPLORE_MENU]: <WrappedExploreConsumerSubmenu />,
      }}
    >
      <ExploreMenuItem />
      <MetaNavMenuItem />
      <GetAppMenuItem />
      <MobileAuthMenuItem buttons={[signUpButtonProps(), logInButtonProps()]} />
    </MobileMenuConfigWrapper>
  );
};

export default DefaultLoggedInMobileMenuConfig;
